import { Box, Grid, List, Typography, styled } from "@mui/material";

import AdvanceTradeAvailableSkeleton from "components/Skeletons/AdvanceTradeAvailable.Skeleton";
import CoinItem from "./CoinItem";
import { getBasketWalletList } from "store/slices/wallet/walletSlice";
import useDispatch from "hooks/useDispatch";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useState } from "react";

function WalletList() {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  const [loading, setLoading] = useState(true);

  const portfolioWalletInfo = useSelector(
    (state) => state.wallet.portfolioWalletList?.data
  );

  const walletList = useSelector(
    (state) => state.wallet?.portfolioBasketMenu?.data
  );
  const walletListFiltered = walletList?.filter(
    (wallet) => wallet.isHaveBasket === true
  );

  const basketId =
    +searchParams.get("basketId") || walletListFiltered?.[0]?.basketId || 0;
  const portfolioId =
    +searchParams.get("portfolioId") ||
    walletListFiltered?.[0]?.portfolioId ||
    0;
  const borrow = searchParams.get("borrow") || ""
  const repay = searchParams.get("repay") || ""

  useEffect(() => {
    const handleBasketList = async () => {
      setLoading(true);

      await dispatch(getBasketWalletList({ id: +basketId, portfolioId }));

      setLoading(false);
    };

    if (basketId && portfolioId) {
      handleBasketList();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [basketId, portfolioId, borrow, repay]);

  return (
    <Grid item xs={12}>
      {!loading ? (
        <>
          <BoxHeader>
            <Typography variant="subtitle1" color="text.secondary">
              Symbol
            </Typography>
            <Typography variant="subtitle1" color="text.secondary">
              AVL
            </Typography>
          </BoxHeader>

          <List sx={{ padding: 0 }} aria-labelledby="nested-list-subheader">
            {portfolioWalletInfo?.map((coin, index) => (
              <CoinItem key={index} coin={coin} />
            ))}
          </List>
        </>
      ) : (
        <AdvanceTradeAvailableSkeleton />
      )}
    </Grid>
  );
}

const BoxHeader = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),
  borderTopRightRadius: "8px",
  borderTopLeftRadius: "8px",
  background: theme.palette.background.primaryGradient,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

export default WalletList;
